import React from 'react';

import Tags from '@/components/Tags';

interface RealisationTagProps {
  title: string;
  websites: string[];
  description: string;
  tags: string[];
}

const PortfolioHeader: React.FC<RealisationTagProps> = ({
  title,
  websites,
  description,
  tags,
}) => {
  return (
    <div className="lg:text-xl">
      <h1 className="mt-[150px] lg:mt-[250px] mb-4">{title}</h1>
      {websites.map((website, i) => (
        <span key={i}>
          {i > 0 && ' & '}
          <a
            className="inline-block mb-8 underline font-bold transition-colors hover:text-primary"
            href={`https://www.${website}`}
            target="_blank"
            rel="noreferrer"
          >
            {website}
          </a>
        </span>
      ))}
      <p className="mb-8 max-w-full lg:max-w-[50%]">{description}</p>

      <div className="mb-8 lg:mb-32">
        <Tags tags={tags} />
      </div>
    </div>
  );
};

export default PortfolioHeader;
